module.exports = __webpack_public_path__ + "img/20d234a.png";